import { render } from "./HistoryDetailsHeader.vue?vue&type=template&id=b0db50da"
import script from "./HistoryDetailsHeader.vue?vue&type=script&lang=js"
export * from "./HistoryDetailsHeader.vue?vue&type=script&lang=js"
script.render = render

export default script